<template>
  <CFormGroup
    v-bind="{validFeedback, invalidFeedback, tooltipFeedback, description, class: computedClasses}"
    :style="wrapperAttrs.style"
    :class="wrapperAttrs.class"
  >
    <template #input>
      <input
        v-bind="controlAttrs"
        :id="safeId"
        :type="inputType"
        :class="inputClasses"
        :checked="state"
        @change="onChange($event)"
      />
    </template>
    <template #label-after-input>
      <slot name="label">
        <label v-if="label || custom" :for="safeId" :class="labelClasses">
          {{label}}
        </label>
      </slot>
    </template>
    <template v-for="slot in passSlots" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </CFormGroup>
</template>

<script>
import { sharedComputedProps } from './form-mixins'
import { inputCheckboxProps as props } from './form-props'
import CFormGroup from './CFormGroup.vue'

export default {
  name: 'CInputCheckbox',
  inheritAttrs: false,
  components: { CFormGroup },
  mixins: [sharedComputedProps],
  props,
  emits: ['update:checked'],
  inputType: 'checkbox',
  data () {
    return { state: undefined }
  },
  watch: {
    checked: {
      immediate: true,
      handler (val) { this.state = val }
    }
  },
  computed: {
    inputType () {
      return this.$options.inputType
    },
    passSlots () {
      return ['valid-feedback', 'invalid-feedback', 'description'].filter((s) => this.$slots[s])
    },
    customType () {
      return this.inputType === 'checkbox' ? 'checkbox' : 'radio'
    },
    computedClasses () {
      const controlClass = this.custom ? 'custom-control' : 'form-check'
      return {
        [`${controlClass}`]: true,
        [`${controlClass}-inline`]: this.inline,
        [`custom-${this.customType}`]: this.custom,
        'was-validated': this.wasValidated
      }
    },
    labelClasses () {
      return [this.addLabelClasses, this.custom ? 'custom-control-label' : 'form-check-label']
    },
    inputClasses () {
      return [this.custom ? 'custom-control-input' : 'form-check-input', this.validationClass, this.addInputClasses]
    }
  },
  methods: {
    onChange (e) {
      this.state = e.target.checked
      this.$emit('update:checked', e.target.checked, e)
    }
  }
}
</script>
